export const NATS_SERVERS = ["connect.ngs.global"];
